(function () {
  'use strict';

  function init() {
    const filtersSidebar = document.querySelector('pipefy-filters-sidebar');
    if (!filtersSidebar) return;

    // Handle search form submission
    const searchForm = filtersSidebar.querySelector('[data-tg-search-form]');
    if (searchForm) {
      return;
    }

    const radioButtons = filtersSidebar.querySelectorAll(
      'input[name="template-type"][type="radio"]'
    );
    if (radioButtons.length === 0) return;

    function updateUrlWithAuthor(authorSlug) {
      const newUrl = new URL(window.location.href);
      authorSlug
        ? newUrl.searchParams.set('filter', authorSlug)
        : newUrl.searchParams.delete('filter');

      window.location.href = newUrl.toString();
    }

    radioButtons.forEach(radio => {
      radio.addEventListener('change', function () {
        console.log('salve');
        if (this.checked) {
          const authorSlug = this.dataset.authorSlug || this.value;
          if (authorSlug) updateUrlWithAuthor(authorSlug);
        }
      });
    });

    filtersSidebar.querySelectorAll('.pipefy-filter').forEach(container => {
      const radio = container.querySelector('input[type="radio"]');
      const link = container.querySelector('a');

      if (radio && link) {
        container.addEventListener('click', function (e) {
          if (e.target.closest('a')) return;

          if (!radio.checked) {
            e.preventDefault();
            radio.checked = true;
            radio.dispatchEvent(new Event('change', { bubbles: true }));
          }
        });
      }
    });
  }

  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', init) : init();
})();
